/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchResultTitle = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The human-readable names of the filter options
		filterTitles: {},

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;

		},

		searchConfigChanged: function() {
			this.$ctx.removeClass('active');
		},

		searchDataAvailable: function(processor, data, config) {
			var mod = this;
			var SearchResultContainer = Module.SearchResultContainer;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			mod.$ctx.addClass('active');

			// Fill in title
			var title = [];
			var resultCount = data.resultCount || 0;
			if(resultCount < 1) {
				title = [
					h('span.scs-noresults-icon'),
					h('span.scs-sitesearch-no-results-content', [SCS.utils.formatString(mod.translations.resultTitleTextNoresults, config.query)])
				];
			} else {
				var translationKey = 'resultTitleText' + (resultCount === 1 ? 'S' : 'P');
				var filterTitles = [];
				for(var filterArea in config.filter) {
					var filterValue = config.filter[filterArea];
					// jshint forin: false
					var titles = mod.filterTitles[filterArea] || {};
					filterTitles.push(titles[filterValue] || filterValue);
				}
				if(!filterTitles.length) {
					translationKey = translationKey + 'NoFilter';
				}
				var suffix = '';
				if(config.previousFilter) {
					suffix = mod.translations.resultTitleTextWithoutFilter;
				}
				var text = mod.translations[translationKey];
				title.push(SCS.utils.formatString(
					text,
					resultCount,
					config.query,
					filterTitles.join(', '),
					suffix
				));
			}
			mod.title = snabbdom.patch(mod.title, h('div.scs-sitesearch-result-title-count.active', title));

			// Handle autocorrection
			var misspelled = [];
			if(config.autoCorrectedFrom) {
				misspelled.push(SCS.utils.formatString(
					mod.translations.resultTitleTextNoresultsForMisspelled,
					config.autoCorrectedFrom
				));
			}
			mod.misspelled = snabbdom.patch(mod.misspelled, h('div.scs-sitesearch-result-title-misspelled', {
				'class': {
					active: !!config.autoCorrectedFrom
				}
			}, misspelled));

			// Handle manual correction
			var suggestion = [];
			if(config.manualCorrectionSuggestion) {
				var newQuery = config.manualCorrectionSuggestion;
				// Don’t use format here because we want to replace the placeholder with a DOM element
				var contents = this.translations.resultTitleTextDidYouMean.split('{0}');
				contents.splice(1, 0, h(
					'span',
					[newQuery]
				));
				suggestion.push(h(
					'a.scs-sitesearch-misspelled-link',
					{
						props: {
							href: '#'+SCS.search.util.param({q: newQuery})
						},
						on: {
							click: function(event) {
								event.preventDefault();
								SearchResultContainer.trackClick('spell', config, {query: newQuery, previousQuery: config.query}, processor);
								mod.searchContainer.query = newQuery;
								mod.searchContainer.configChanged();
							}
						}
					},
					contents
				));
			}
			this.suggestion = snabbdom.patch(this.suggestion, h('div.scs-sitesearch-result-title-suggestion', {
				'class': {
					active: !!config.manualCorrectionSuggestion
				}
			}, suggestion));
		},

		findElements: function() {
			this.translations = this.$ctx.data();

			this.title = this.$ctx.find('.scs-sitesearch-result-title-count')[0];
			this.misspelled = this.$ctx.find('.scs-sitesearch-result-title-misspelled')[0];
			this.suggestion = this.$ctx.find('.scs-sitesearch-result-title-suggestion')[0];

			var filterModule = this.searchContainer.internalModulesByName('SearchResultFilter')[0];
			if(filterModule) {
				this.filterTitles = filterModule.getFilterTitles();
			}
		}

	});

	Module.SearchResultTitle = SearchResultTitle;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultTitle.js
// module id = 65
// module chunks = 0